<template>
  <div class="productDetail_wrap" v-loading="loading">
    <div  class="crumbs">
      <p>
        <a href="/home" target="">首页</a> /
        <a href="/table" target="">产品展示</a> /
        <a href="" target="">{{title}}</a>
      </p>
    </div>
    <!-- 用v-html渲染富文本，替代手动DOM操作 -->
    <div class="productDetail_item" v-html="richTextContent"></div>
  </div>
</template>

<script>
import {getPortalCategoryDetailVoById} from "@/api/home";

export default {
  name: "ProductDetail",
  data() {
    return {
      loading: false,
      richTextContent: "", // 存储过滤后的富文本内容
      title: '',
      // 维护type与接口的映射关系
      apiMap: {
        table: getPortalCategoryDetailVoById, // type=service 调用旗下品牌详情接口
      },
    };
  },

  watch: {
    // 监听路由query整体变化（同时监听productId和type）
    "$route.query": {
      immediate: true,
      handler(newQuery) {
        const { productId, type } = newQuery;
        // 先校验必填参数
        if (!productId) {
          this.$message.warning(this.getTypeName(type)+"ID不能为空");
          this.richTextContent = "";
          return;
        }
        if (!type) {
          this.$message.warning("类型参数不能为空");
          this.richTextContent = "";
          return;
        }
        // 校验type是否在合法映射中
        if (!this.apiMap[type]) {
          this.$message.error(`不支持的类型：${type}`);
          this.richTextContent = "";
          return;
        }
        // 调用通用获取详情方法
        this.getDetailByType(type, productId);
      },
    },
  },
  methods: {

    /**
     * 根据type调用对应接口获取详情
     * @param {string} type 类型（product/service/activity）
     * @param {string/number} id 产品/服务/活动ID
     */
    async getDetailByType(type, id) {
      try {
        this.loading = true;
        // 根据type从映射表中获取对应接口函数并执行
        const apiFunc = this.apiMap[type];
        const res = await apiFunc(id);

        if (res.code === 200) {
          const data = res.data[0];
          this.title = data.name;
          this.richTextContent = data.content || "";
        } else {
          this.$message.error(res.msg || `获取${this.getTypeName(type)}详情失败`);
          this.richTextContent = "";
        }
      } catch (error) {
        console.error(`${this.getTypeName(type)}详情请求失败：`, error);
        this.$message.error("网络异常，请稍后重试");
        this.richTextContent = "";
      } finally {
        this.loading = false;
      }
    },

    /**
     * 转换type为中文名称
     * @param {string} type 类型标识
     * @returns {string} 中文名称
     */
    getTypeName(type) {
      const nameMap = {
        product: "产品展示",
        brand: "旗下品牌",
      };
      return nameMap[type] || "未知";
    },
  },
};
</script>

<style scoped lang="scss">
// 补充基础布局：确保body/html高度占满，避免居中失效
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

// 父容器：水平居中 + 可选垂直居中（根据需求）
.productDetail_wrap {
  width: 100%; // 容器宽度可根据需求调整（比如70%/1200px）
  height: 100%;
  margin: 0 auto; // 核心：水平居中（最常用）
  padding-top: 40px;
  //max-width: 1200px;
  // 子容器：内容居中
  :deep(.productDetail_item) {
    width: 100%;
    height: 100%;
    box-sizing: border-box; // 防止padding/margin撑宽容器

    p {
      img {
        width: 100% !important;
        //max-width: 1200px; // 限制图片最大宽度，避免过宽
        height: auto; // 自适应高度，防止变形
        margin: 0 auto; // 兜底：确保图片块级居中
      }
    }

    // 富文本中块级元素（表格/容器）居中
    table,
    .rich-text-container,
    iframe {
      margin: 0 auto; // 块级元素水平居中
      max-width: 100%; // 不超出父容器
    }

    // 兼容其他富文本标签
    img,
    video {
      height: auto;
    }

    p,
    div,
    span {
      text-align: center; // 文字居中
      line-height: 1.8; // 优化行高，提升可读性
    }
  }
}

.crumbs{
  bottom: 38px;
  left: 9%;
  padding: 20px 40px;
  background: rgba(255, 255, 255, .7);
  margin-top: 60px;
}
.crumbs p{
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.crumbs p a{
  display: inline-block;
  vertical-align: top;
  margin: 0 10px;
}
.crumbs p a:first-child{
  margin-left: 0;
}
.crumbs p a:hover{
  color: #000;
}
.crumbs h2{
  font-size: 30px;
  color: #555;
}
</style>